/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowCollapseTrianglesHClosedIcon16Light } from './ArrowCollapseTrianglesHClosedIcon16Light';
import { ArrowCollapseTrianglesHClosedIcon16Regular } from './ArrowCollapseTrianglesHClosedIcon16Regular';
import { ArrowCollapseTrianglesHClosedIcon16Solid } from './ArrowCollapseTrianglesHClosedIcon16Solid';
import { ArrowCollapseTrianglesHClosedIcon20Light } from './ArrowCollapseTrianglesHClosedIcon20Light';
import { ArrowCollapseTrianglesHClosedIcon20Regular } from './ArrowCollapseTrianglesHClosedIcon20Regular';
import { ArrowCollapseTrianglesHClosedIcon20Solid } from './ArrowCollapseTrianglesHClosedIcon20Solid';
import { ArrowCollapseTrianglesHClosedIcon24Regular } from './ArrowCollapseTrianglesHClosedIcon24Regular';
import { ArrowCollapseTrianglesHClosedIcon24Solid } from './ArrowCollapseTrianglesHClosedIcon24Solid';
import { ArrowCollapseTrianglesHClosedIcon32Regular } from './ArrowCollapseTrianglesHClosedIcon32Regular';
import { ArrowCollapseTrianglesHClosedIcon64Regular } from './ArrowCollapseTrianglesHClosedIcon64Regular';
var sizes = {
    16: {
        light: ArrowCollapseTrianglesHClosedIcon16Light,
        regular: ArrowCollapseTrianglesHClosedIcon16Regular,
        solid: ArrowCollapseTrianglesHClosedIcon16Solid,
    },
    20: {
        light: ArrowCollapseTrianglesHClosedIcon20Light,
        regular: ArrowCollapseTrianglesHClosedIcon20Regular,
        solid: ArrowCollapseTrianglesHClosedIcon20Solid,
    },
    24: {
        regular: ArrowCollapseTrianglesHClosedIcon24Regular,
        solid: ArrowCollapseTrianglesHClosedIcon24Solid,
    },
    32: {
        regular: ArrowCollapseTrianglesHClosedIcon32Regular,
    },
    64: {
        regular: ArrowCollapseTrianglesHClosedIcon64Regular,
    },
};
export var ArrowCollapseTrianglesHClosedIcon = forwardRef('ArrowCollapseTrianglesHClosedIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
